import type { ChipDefinition } from '@/types/hid8051';

/**
 * Nuvoton N76E003 — 8051 core, 18 KB APROM, 4 KB LDROM max, 128 B pages
 * Device ID: 0x00003650
 */
export const N76E003: ChipDefinition = {
  name: 'N76E003',
  family: 'nuvoton-8051',
  deviceId: 0x00003650,
  flashSize: 18 * 1024,       // 18 KB APROM
  ldromMaxSize: 4 * 1024,     // 4 KB LDROM max
  pageSize: 128,              // 128 byte erase pages
  configSize: 5,              // 5 config bytes
};
